/**
 * Connect RPC Client Configuration
 */

import { createConnectTransport } from '@connectrpc/connect-web';
import { mockTransport } from './mock/transport';
import { apiConfig } from './config';
import { authInterceptor } from './interceptors/auth';
import { refreshInterceptor } from './interceptors/refresh';

// Real transport for production
const realTransport = createConnectTransport({
  baseUrl: apiConfig.baseUrl,
  // C3: Enable Credentials for Cookie-based Auth
  // Note: credentials must be passed via custom fetch function
  fetch: (input, init) => fetch(input, { ...init, credentials: 'include' }),
  interceptors: [
    authInterceptor,
    refreshInterceptor
  ],
});

// Export the appropriate transport based on configuration
export const transport = apiConfig.useMock ? mockTransport : realTransport;

